module.exports = __webpack_public_path__ + "media/adc.90628bc3.mp4";